/**
 * @vuepress
 * ---
 * title: fileTypeTransformer
 */

import Transformer from '../transformer'

/**
 * @class fileTypeTransformer
 * Info file types
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class fileTypeTransformer extends Transformer {
  static fetch(file) {
    return {
      'id': file.id,
      'codename': file.codename,
      'slug': file.slug,
      'name': file.name,
      'description': file.description,
      'maxSize': file.max_size,
      'requiresSignatureDate': file.require_signature_date
    }
  }
}
export default fileTypeTransformer
